module.exports = __webpack_public_path__ + "static/media/sheYes.bd1c2612.jpg";